import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-legend-input',
  templateUrl: './legend-input.component.html',
  styleUrls: ['./legend-input.component.css']
})
export class LegendInputComponent {

  @Input() label: string;
  
  constructor() { }

}
